import React, { Suspense, useEffect, useState } from 'react';
import Spinner from '@components/Spinner';

const HydrationSuspense = ({
  fallback = <Spinner />,
  children,
  ssrOnly = false,
  disableWrapper = false,
}) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return ssrOnly ? children : <div style={{ minHeight: '100px' }}></div>;
  }

  const content = <Suspense fallback={fallback}>{children}</Suspense>;

  return disableWrapper ? content : (
    <div className="content-visibility-auto">{content}</div>
  );
};

export default HydrationSuspense;
